import { Directive, ElementRef, Input, inject } from '@angular/core';

@Directive({
	selector: '[scroll-if]',
	standalone: true
})
export class ScrollIfDirective {
	private el = inject(ElementRef);

	private _condition: boolean;

	@Input('scroll-if') set condition(value: boolean) {
		this._condition = value;
		if (value) {
			this.scrollIfNotInView();
		}
	}
	get condition(): boolean {
		return this._condition;
	}

	getElementScrollPosition() {
		return this.el.nativeElement.offsetTop - this.el.nativeElement.parentElement.offsetTop;
	}

	scrollIfNotInView() {
		if (!this.isInView()) this.el.nativeElement.parentElement.scrollTop = this.getElementScrollPosition();
	}

	isInView() {
		const elementPosition = this.getElementScrollPosition();
		const containerHeight = this.el.nativeElement.parentElement.offsetHeight;
		const visibleUpper = this.el.nativeElement.parentElement.scrollTop;
		const visibleLower = visibleUpper + containerHeight;
		return elementPosition >= visibleUpper && elementPosition <= visibleLower;
	}
}
